import { useQuery } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useEvents(data, options, key = "getEvents") {
  const axiosPrivate = useAxiosPrivate();

  const getEvents = async () => {
    const events = await axiosPrivate({
      method: "POST",
      url: "/Logs/GetLogsByFilter2",
      data,
    }).then((res) => res.data);
    return events;
  };

  return useQuery([key, data], () => getEvents(data), {
    ...options,
  });
}

export default useEvents;
